import Premier from './Premier';

export default Premier;